module.exports = __webpack_public_path__ + "static/img/weinxin-pay.21f0a22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/weinxin-pay.png
// module id = MfEM
// module chunks = 1